import { ChecksIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CheckDouble = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <ChecksIcon size={Sizes[size]} {...rest} color={fill} />;
};

CheckDouble.displayName = 'CheckDouble';
